export default {
	faqs: {
		createCategory: 'Create Category',
		createEntry: 'Create Entry',
		faqCategory: 'FAQ Category | FAQ Categories',
		faqEntry: 'FAQ Entry | FAQ Entries',
	},
}
